import { createTheme } from "@material-ui/core/styles"

export const theme = createTheme({
  palette: {
    primary: { main: "#EF4A22" },
    secondary: { main: "#6204BF" },
    background: {
      tableHead: "#F5F5F5",
    },
  },
})
